<lib-modal #modal>
  <lib-modal-dialog class="delete-verification-modal">
    <lib-modal-dialog-header>
      <span>Delete File</span>
    </lib-modal-dialog-header>

    <lib-modal-dialog-body class="delete-verification-modal__body">
      <span class="delete-verification-modal__body-message">
        {{ message }}
      </span>
    </lib-modal-dialog-body>

    <lib-modal-dialog-footer class="delete-verification-modal__footer">
      <lib-button [type]="buttonType.Secondary" (click)="onButtonClick(deleteVerificationModalActions.Cancel)">
        Cancel
      </lib-button>

      <lib-button [type]="buttonType.Primary" (click)="onButtonClick(deleteVerificationModalActions.Delete)">
        Delete
      </lib-button>
    </lib-modal-dialog-footer>
  </lib-modal-dialog>
</lib-modal>
